module.exports = __webpack_public_path__ + "static/media/truckhighway.3e32fdb7.jpg";